import React from 'react'
import { Helmet } from 'react-helmet'
import ActiveCatalogue from '../../components/ActiveCatalogue/ActiveCatalogue'
import BrandLogoSlider from '../../components/BrandLogoSlider'
import ReportDetails from '../../components/ReportDetail/ReportDetail'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

const ReportDetailPage = () => {
    return (
        <>
            <Helmet>
                <title>Report Details</title>
            </Helmet>
            <Header />
            <ActiveCatalogue />
            <ReportDetails />
            <BrandLogoSlider />
            <Footer displayFooterTop={false} />
        </>
    )
}

export default ReportDetailPage